import { useState } from 'react';
import { useHistory } from 'react-router-dom';

export const useHighlight = () => {
  const [isHighlight, setIsHighlight] = useState(false);

  const highlightElement = (targetID: string) => {
    const elem = document.getElementById(targetID);
    if (elem) {
      elem.classList.add('highlightActive');
      elem.classList.add('overlayActive');
      setIsHighlight(true);
    }
  };

  const removeHighlightElement = (targetID: string) => {
    const elem = document.getElementById(targetID);
    if (elem) {
      elem.classList.remove('overlayActive');
      elem.classList.remove('highlightActive');
      setIsHighlight(false);
    }
  };

  return {
    highlightElement,
    removeHighlightElement,
    isHighlight,
  };
};

export const usePreview = () => {
  const [isPreview, setIsPreview] = useState(false);

  const handlePreviewMode = () => {
    setIsPreview(!isPreview);
  };

  return [isPreview, handlePreviewMode];
};

export const useOpenOverviewOnboardingPage = () => {
  const history = useHistory();

  const openOverviewOnboardingPage = () => {
    history.push('/airbnb-data/landing');
  };

  return openOverviewOnboardingPage;
};

export const useCalculatorLandingPage = () => {
  const history = useHistory();

  const openOverviewOnboardingPage = () => {
    history.push('/airbnb-calculator');
  };

  return openOverviewOnboardingPage;
};
